import { render, staticRenderFns } from "./WxBase.vue?vue&type=template&id=2bf9c750&"
import script from "./WxBase.vue?vue&type=script&lang=js&"
export * from "./WxBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports